import Users from "./users";
import Roles from "./roles";
const UsersHolder = () => {
   return (
      <>

         <div className="row">
            <div className="col-12">
               <div className="page-title-box">
                  <h4 className="page-title lh-1 mb-3">Settings Details</h4>
               </div>
            </div>
         </div>
         <div className="row">
            <div className="col-md-12">
               <div className="card  ">
                  <div className="card-body">
                     <div className=" ">
                        <ul className="nav nav-tabs mb-3" role="tablist">
                           <li className="nav-item" role="presentation">
                              <a href="#home" data-bs-toggle="tab" aria-expanded="false" className="nav-link active" aria-selected="true" tabindex="-1" role="tab">
                                 User Management
                              </a>
                           </li>
                           <li className="nav-item" role="presentation">
                              <a href="#profile" data-bs-toggle="tab" aria-expanded="true" className="nav-link " aria-selected="false" role="tab" tabindex="-1">
                                 Role Management
                              </a>
                           </li>
                        </ul>
                        <div className="tab-content">
                           <div className="tab-pane show active" id="home" role="tabpanel">
                              <Users />
                           </div>

                           <div className="tab-pane " id="profile" role="tabpanel">
                              <Roles />
                           </div>
                        </div>
                     </div>
                  </div>

               </div>
            </div>

         </div>


      </>
   )
}

export default UsersHolder;